import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Form from "../../common/form";
import CustomBreadCrumbs from "../../common/breadcrumbs";
import { Button } from "primereact/button";
import AccountPreferencesForm from "./AccountPreferencesForm";
import { GlobalConstants } from "../../../constants";
import {
  updateAccountPreferencesRequest,
  userDetailsRequest,
} from "../../../store/slices/selfSlice";

const AccountPreferences = ({
  user,
  updateAccountPreferences,
  userDetails,
  error,
  action,
  requesting,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [isEditable, setIsEditable] = useState(false);

  const handleUpdatePreferences = (values) => {
    const payload = {
      languageSettings: {
        preferredLanguage: values.preferredLanguage?.id || "en",
      },
    };
    updateAccountPreferences(payload);
  };

  const getSelectedLanguage = () => {
    const selectedLanguage =
      GlobalConstants.LANGUAGES.find(
        (lang) => lang?.code === user?.preferredLanguage
      ) || GlobalConstants.LANGUAGES.find((lang) => lang?.code === "en");
    return {
      ...selectedLanguage,
      id: selectedLanguage.code,
      name: selectedLanguage.name,
    };
  };

  useEffect(() => {
    if (!error && !requesting && action === "update-account-preferences") {
      userDetails();
      setIsEditable(false);
    }
  }, [error, requesting, action, userDetails]);

  return (
    <div className="">
      <CustomBreadCrumbs
        labels={[
          {
            label: "account_preferences",
          },
        ]}
        navigate={navigate}
      />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "account_preferences" })}
          </div>
          {(!isEditable && (
            <div className="edexlms-page-actions">
              <Button
                icon="pi pi-pencil"
                outlined
                onClick={() => setIsEditable(!isEditable)}
                label={intl.formatMessage({ id: "edit" })}
                type="button"
                size="small"
              />
            </div>
          )) ||
            null}
        </div>
        <div className="edexlms-page-body">
          <Form
            initialValues={{
              preferredLanguage: getSelectedLanguage(),
            }}
            submitBtn={{
              label: intl.formatMessage({ id: "update_account_preferences" }),
              onClick: handleUpdatePreferences,
            }}
            disabled={!isEditable}
            cancelBtn={{
              label: intl.formatMessage({ id: "cancel" }),
              onClick: () => {
                setIsEditable(false);
              },
            }}
          >
            <AccountPreferencesForm disabled={!isEditable} />
          </Form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.self?.user,
  action: state.self?.action,
  requesting: state.self?.requesting,
  error: state.self?.error,
});

const mapDispatchToProps = (dispatch) => ({
  updateAccountPreferences: (data) =>
    dispatch(updateAccountPreferencesRequest(data)),
  userDetails: () => dispatch(userDetailsRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountPreferences);
